import React from 'react';

export function FeaturesSection({ heading, children }) {
  return (
    <section className='features-section'>
      <div className='container'>
        {heading ? <h2>{heading}</h2> : null}
        <div className='features-grid'>{children}</div>
      </div>
    </section>
  );
}

export function FeatureCard({ icon = null, title, children, footer = null }) {
  // Check if children contains p tags to avoid nesting
  const hasPTags = React.Children.toArray(children).some(
    child => React.isValidElement(child) && child.type === 'p'
  );

  return (
    <div className='feature-card'>
      {icon ? <div className='feature-icon'>{icon}</div> : null}
      {title ? <h3>{title}</h3> : null}
      {children ? (
        hasPTags ? children : <p>{children}</p>
      ) : null}
      {footer}
    </div>
  );
}
